import { gql } from '@apollo/client';

export const MY_PROJECTS = gql`
  query MyProjects {
    myProjects {
      id
      ownerId
      owner {
        id
        name
        email
      }
      name
      status
      meta
      createdAt
      updatedAt
      users {
        id
        email
        name
        role
      }
      phases {
        id
        projectId
        name
        type
        progress
        sequence
        locked
        status
        isActive
        isHidden
        meta
        data
        users {
          id
          email
          name
          role
        }
        notes {
          id
          text
          createdAt
          authorId
        }
      }
    }
  }
`;

export const PROJECT = gql`
  query Project($id: ID!) {
    project(id: $id) {
      id
      ownerId
      owner {
        id
        name
        email
      }
      name
      status
      meta
      createdAt
      updatedAt
      users {
        id
        email
        name
        role
      }
      phases {
        id
        projectId
        name
        type
        progress
        sequence
        locked
        status
        isActive
        isHidden
        meta
        data
        users {
          id
          email
          name
          role
        }
        notes {
          id
          text
          createdAt
          authorId
        }
      }
    }
  }
`;

export const PROJECTS = gql`
  query Projects($filter: ProjectFilterInput, $page: Int, $pageSize: Int) {
    projects(filter: $filter, page: $page, pageSize: $pageSize) {
      items {
        id
        ownerId
        owner {
          id
          name
          email
        }
        name
        status
        createdAt
        updatedAt
        users {
          id
          email
          name
          role
        }
        phases {
          id
          name
          type
          sequence
          progress
          locked
          status
          isActive
          isHidden
        }
      }
      totalCount
    }
  }
`;
